/* BOLODOO card swatch navigation v1 */
(() => {
  const selector = '.collection-product-card [data-card-swatch-overflow]';
  const desktop = window.matchMedia('(min-width: 750px)');
  const groups = new WeakMap();

  function children(parent, selector) {
    return Array.from(parent.children).filter(node => node.matches(selector));
  }

  function sync(overflow) {
    const container = overflow.parentElement;
    const storage = overflow.querySelector(':scope > [hidden]');
    const link = overflow.querySelector(':scope > .card-swatch-more-link');
    if (!container || !storage || !link) return;
    let state = groups.get(overflow);
    if (!state) {
      const linked = overflow.classList.contains('card-linked-swatches-more');
      const records = [container, storage].flatMap(parent => children(parent, linked ? '.card-linked-swatch' : 'input').map(node => {
        if (linked) return { color: node.getAttribute('aria-label') || node.title, nodes: [node] };
        const label = children(parent, 'label').find(label => label.htmlFor === node.id);
        return { color: node.value, nodes: label ? [node, label] : [node] };
      }));
      state = { records: window.BolodooSwatchOrder?.sortColorRecords(records) || records, limit: 0, start: -1 };
      groups.set(overflow, state);
    }
    const limit = desktop.matches ? 5 : 4;
    const selectedIndex = state.records.findIndex(({ nodes }) => nodes.some(node =>
      node.checked || node.classList.contains('active') || node.getAttribute('aria-current') === 'true'));
    const { start, end } = window.BolodooSwatchOrder?.cardSwatchWindow(state.records.length, selectedIndex, limit) ||
      { start: 0, end: Math.min(limit, state.records.length) };
    if (state.limit === limit && state.start === start) return;
    // Move only a contiguous slice, keeping the selected color in its sorted position.
    state.records.forEach(({ nodes }, index) => nodes.forEach(node => {
      if (index >= start && index < end) container.insertBefore(node, overflow);
      else storage.appendChild(node);
    }));
    state.limit = limit;
    state.start = start;
    const remaining = Math.max(0, state.records.length - (end - start));
    overflow.hidden = remaining === 0;
    link.textContent = `+${remaining}`;
    link.setAttribute('aria-label', `View ${remaining} more colors on the product page`);
  }

  function syncAll() {
    document.querySelectorAll(selector).forEach(sync);
  }

  // These links follow the same product or variant as the existing color preview.
  document.addEventListener('click', event => {
    const swatch = event.target.closest('[data-linked-card-swatch], [data-native-variant-card-preview]');
    const card = swatch?.closest('.collection-product-card');
    if (!card) return;
    const input = swatch.matches('label') ? document.getElementById(swatch.htmlFor) : null;
    const href = swatch.getAttribute('data-linked-product-url') || swatch.getAttribute('href') || input?.getAttribute('data-variant-link');
    if (href) card.querySelectorAll('.card-swatch-more-link').forEach(link => link.setAttribute('href', href));
  });
  document.addEventListener('change', event => {
    if (!event.target.matches('.collection-product-card .js-color-swatches input[type="radio"]')) return;
    const overflow = event.target.closest('.product-form__controls-group')?.querySelector('[data-card-swatch-overflow]');
    if (overflow) sync(overflow);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncAll, { once: true });
  else syncAll();
  desktop.addEventListener('change', syncAll);
  document.addEventListener('shopify:section:load', syncAll);
  // Filtering and lazy-loaded recommendations can insert cards after page load.
  new MutationObserver(records => {
    if (records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1 && (
      node.matches('.collection-product-card, [data-card-swatch-overflow]') || node.querySelector('[data-card-swatch-overflow]')
    )))) syncAll();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
